export default __webpack_public_path__ + "static/reactjs-development-company-peerbits-f27ba102fd6bcd7fc4c5e1600fac0506.png";